export default __webpack_public_path__ + "static/media/shannel.0e488066.jpg";